import { Grid, MenuItem, Select, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../../../components/Maincard";
import HeadingCard from "../../../newComponent/NewCardsComp/HeadingCard";
import CustomAutocompleteComp from "../../../newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../../newComponent/customTextFieldComp";
import SearchButton from "../../../newComponent/NewButtonComp/SearchButton";
import ClearButtonComp from "../../../newComponent/NewButtonComp/ResetButtonComp";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import Search from "../../../layout/MainLayout/Header/Search/Search";
import SearchTextFieldComp from "../../../newComponent/newtextfieldComp/SearchTextFieldComp";
import { CSVExport } from "../../../components/ui-component/table/CSVExport";
import LoaderComp from "../../../newComponent/LoaderComp/Loader";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function WebsiteWiseEnquiries() {
  const userId = localStorage.getItem("userId");
  const [websiteList, setWebsiteList] = React.useState([]);
  const [website, setWebsite] = React.useState([]);
  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [originalData, setOriginalData] = React.useState([]);
  const [websiteWiseEnquiriesData, setWebsiteWiseEnquiriesData] =
    React.useState([]);

  const [pagination, setPagination] = useState({ page: 0, pageSize: 100 });
  const [filterType, setFilterType] = useState("today");
  const [exportData, setExportData] = useState([]);
  const [isDownloadAccess, setIsDownloadAccess] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const [pageUrlList, setPageUrlList] = useState([]);
const [selectedPageUrls, setSelectedPageUrls] = useState([]);

console.log("selectedPageUrls at 40=",selectedPageUrls );


  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    fetch(`${API_ENDPOINT}route/downloadaccess/${userId}`)
      .then((response) => {
        if (response.ok) {
          setIsDownloadAccess(true);
        } else {
          setIsDownloadAccess(false);
        }
      })
      .catch((err) => {
        setIsDownloadAccess(false);
      });
  }, [userId]);

 useEffect(() => {
  fetch(`${API_ENDPOINT}website-page-url`)
    .then((res) => res.json())
    .then((data) => {
      if (data.status === 200) {
        setPageUrlList(data.data);
      }
    })
    .catch((err) => {
      console.error("Error fetching page URLs:", err);
    });
}, []);

  const columns = [
    {
      field: "enuiry_name",
      headerName: "Enquiry Name",
      width: 100,
      minWidth: 200,
      headerClassName: "header-cell",
      // valueGetter: (params) => `${params.row?.type_of_walking || ""}`,

      
      renderCell: (params) => (
        <Typography style={{ color: "#2196F3", cursor: "pointer" }} onClick={() =>
            window.open(
              `/enquirydetails/${params?.row?.id}`,
              "_blank"
            )
          }>
          {" "}
          {params.row?.first_name} {params.row?.last_name}
        </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      minWidth: 250,
      headerClassName: "header-cell",
      // valueGetter: (params) => `${params.row?.type_of_walking || ""}`,
      renderCell: (params) => <Typography> {params.row?.email} </Typography>,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 100,
      minWidth: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.type_of_walking || ""}`,
      renderCell: (params) => (
        <Typography>
          {" "}
          {params.row?.mobile_country_code} {params.row?.mobile}{" "}
        </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "enquiry_date",
      headerName: "Enquiry Date",
      width: 150,
      minWidth: 200,
      headerClassName: "header-cell",
      // valueGetter: (params) => `${params.row?.type_of_walking || ""}`,
      renderCell: (params) => (
        <Typography> {params.row?.enquiry_date} </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },

    // {
    //   field: "website_name",
    //   headerName: "Website Name",
    //   width: 150,
    //   minWidth: 200,
    //   headerClassName: "header-cell",
    //   valueGetter: (params) => `${params.row?.type_of_walking || ""}`,
    //   renderCell: (params) => (
    //     <Typography> {params.row?.type_of_walking} </Typography>
    //   ),
    //   headerAlign: "center",
    //   align: "center",
    // },

    {
      field: "intrested_in",
      headerName: "Intrested In",
      width: 150,
      minWidth: 200,
      headerClassName: "header-cell",
      // valueGetter: (params) => `${params.row?.type_of_walking || ""}`,
      renderCell: (params) => (
        <Typography> {params.row?.sub_service_id?.name} </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "city",
      headerName: "City",
      width: 150,
      minWidth: 200,
      headerClassName: "header-cell",
      // valueGetter: (params) => `${params.row?.type_of_walking || ""}`,
      renderCell: (params) => (
        <Typography> {params.row?.city_id?.city_name} </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "nearest_branch",
      headerName: "Nearest Branch",
      width: 150,
      minWidth: 200,
      headerClassName: "header-cell",
      // valueGetter: (params) => `${params.row?.type_of_walking || ""}`,
      renderCell: (params) => (
        <Typography> {params.row?.nearest_branch_id?.branch_name} </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "assigned_to",
      headerName: "Assigned To",
      width: 150,
      minWidth: 200,
      headerClassName: "header-cell",
      // valueGetter: (params) => `${params.row?.type_of_walking || ""}`,
      renderCell: (params) => (
        <Typography>
          {" "}
          {params.row?.assign_to?.first_name}{" "}
          {params.row?.assign_to?.last_name}{" "}
        </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },
     {
      field: "page_url",
      headerName: "Page URL",
      width: 250,
      minWidth: 300,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <Typography>
          {" "}
          {params.row?.page_url}

        </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },
  ];

  const handleFilterChange = (event) => {
    setFromDate(null);
    setToDate(null);
    setFilterType(event.target.value);
  };

  const handleReset = () => {
    setWebsite([]);
    setFromDate("");
    setToDate("");
    setWebsiteWiseEnquiriesData([]);
    setFilterType("today");
    setSelectedPageUrls([]); // ✅ added
  };

  const handlefetchData = async () => {
    setLoading(true);
    const requestData = {
      user_id: parseInt(userId),
      filter: filterType,
      from_date: fromDate,
      to_date: toDate,
      page_url_id: selectedPageUrls.map((item) => item.id), // ✅ important
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/scholastictestmasters-website-data`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        },
      );
      const data = await response.json();

      if (data.status === 200) {
        if (data?.data?.length === 0) {
          showSnackbar("No data found for this filter", "error");
        }
        setWebsiteWiseEnquiriesData(data?.data);
        setOriginalData(data?.data);
        setLoading(false);
      } else {
        showSnackbar(data.message, "error");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      showSnackbar("Error fetching data", "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    handlefetchData();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = websiteWiseEnquiriesData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.first_name || ""} ${data?.last_name || ""}`,

        `${data?.email || ""}`,

        ` ${data?.mobile_country_code || ""}${data?.mobile || ""}`,

        `${data?.enquiry_date || ""}`,

        ` ${data?.sub_service_id?.name || ""}`,

        `${data?.city_id?.city_name || ""}`,
        `${data?.nearest_branch_id?.branch_name || ""}`,
        `${data?.assign_to?.first_name || ""} ${
          data?.assign_to?.last_name || ""
        }`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value),
      );
    });

    setOriginalData(filteredData1); // Update the filtered data
  };

  useEffect(() => {
    const exportData = originalData.map((row) => ({
      "First Name": row.first_name,
      "Last Name": row.last_name,
      Email: row.email,
      Mobile: `${row.mobile_country_code}${row.mobile}`,
      "Enquiry Date" : row.enquiry_date,
      "Sub Service": row.sub_service_id?.name,

      City: row.city_id?.city_name,
      "Nearest Branch": row.nearest_branch_id?.branch_name,
      "Assigned To": `${row.assign_to?.first_name} ${row.assign_to?.last_name}`,
    }));
    setExportData(exportData);
  }, [originalData]);

  return (
    <>
      <LoaderComp isLoading={loading} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5} md={4}>
          <HeadingCard label="scholastictestmasters Website  Enquiries" />
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              {/* <Grid item xs={12} lg={4} sm={6} md={3}>
              <Typography variant="h6">Website</Typography>
              <CustomAutocompleteComp
                fullWidth
                value={website}
                multiple
                onChange={(website) => setWebsite(website)}
                options={websiteList}
                getOptionLabel={(option) => option.name}
                tooltipContent={(option) => option.name}
              />
            </Grid> */}

                <Grid item xs={12} lg={5} md={4} sm={6}>
  <Typography variant="h6">Page URL</Typography>

 <CustomAutocompleteComp
  fullWidth
  multiple
  value={Array.isArray(selectedPageUrls) ? selectedPageUrls : []}
  onChange={(event, value) => setSelectedPageUrls(value || [])}
  options={Array.isArray(pageUrlList) ? pageUrlList : []}
  getOptionLabel={(option) => option?.name || ""}
  tooltipContent={(option) => option?.name || ""}
/>
</Grid>
              <Grid item xs={12} lg={2} md={4} sm={6}>
                <Typography variant="h6">
                  Enquiry Created Date Filter
                </Typography>
                <Select
                  value={filterType}
                  onChange={handleFilterChange}
                  fullWidth
                  style={{ borderRadius: "10px" }}
                  size="medium"
                >
                  <MenuItem value="today">Today</MenuItem>
                  <MenuItem value="currentweek">This Week</MenuItem>
                  <MenuItem value="currentmonth">This Month</MenuItem>
                  <MenuItem value="custom">Custom</MenuItem>
                </Select>
              </Grid>

              {filterType === "custom" && (
                <>
                  <Grid item xs={12} sm={3} md={2}>
                    <Typography variant="h6">From Date</Typography>
                    <CustomTextFieldComp
                      size="normal"
                      fullWidth
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      type="date"
                    />
                  </Grid>

                  <Grid item xs={12} sm={3} md={2}>
                    <Typography variant="h6">To Date</Typography>
                    <CustomTextFieldComp
                      size="normal"
                      fullWidth
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      type="date"
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12} sm={12} md={3} ml={2}>
                <Typography variant="h6" sx={{ visibility: "hidden" }}>
                  To Date
                </Typography>
                <Grid container gap={2}>
                  <SearchButton
                    showIcon={true}
                    label="Search"
                    onClick={handlefetchData}
                  />

                  {/* <ClearButtonComp label="Clear" onClick={handleReset} /> */}
                </Grid>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} container gap={2} justifyContent="end">
                <SearchTextFieldComp
                  // value={value}
                  onChange={handleSearch}
                />

                {isDownloadAccess && (
                  <CSVExport
                    data={exportData}
                    filename="Website Wise Enquiries.csv"
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <DataGrid
                  rows={originalData}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: () => (
                      <CustomNoRowsOverlay message="No Data Available" />
                    ),
                  }}
                  paginationModel={pagination}
                  onPaginationModelChange={(model) => setPagination(model)}
                  pageSizeOptions={[10, 25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
